var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y, _z, _0, _1, _2, _3, _4, _5, _6, _7, _8, _9, _10, _11, _12, _13, _14, _15, _16, _17, _18, _19, _20, _21, _22, _23, _24, _25, _26, _27, _28, _29, _30, _31, _32, _33, _34, _35, _36, _37, _38, _39, _40, _41, _42, _43, _44, _45, _46, _47, _48, _49, _50, _51, _52, _53, _54, _55, _56, _57, _58, _59, _60, _61, _62, _63, _64, _65, _66, _67, _68, _69, _70, _71, _72, _73, _74, _75, _76, _77, _78, _79, _80, _81, _82, _83, _84, _85, _86, _87, _88, _89, _90, _91, _92, _93, _94, _95, _96, _97, _98, _99, _100, _101, _102, _103, _104, _105, _106, _107, _108, _109, _110, _111, _112, _113, _114;
import { __awaiter, __decorate, __metadata } from "tslib";
import { Mutation, Action, VuexModule, Module } from 'vuex-module-decorators';
import axios from 'axios';
import ApiService from '@/core/services/ApiService';
import { Actions, Mutations } from '@/store/enums/finance/MappingProfillingEnums';
let HierarchyModule = class HierarchyModule extends VuexModule {
    constructor() {
        super(...arguments);
        this.wasFirstLoad = true;
        this.wasAssetFirstLoad = true;
        this.loading = false;
        this.mappingProfillingList = [];
        this.mappingProfillingPaging = [];
        this.useFilter = true;
        this.loadPage = false;
        this.page = 1;
        this.size = 10;
        this.desc = '';
        this.searchBy = '';
        this.status = '';
        this.statusMessage = '';
        this.resetMappingProfilling = true;
        this.ddlFilterCompanyCode = [];
        this.ddlFilterAssetNumber = [];
        this.ddlFilterAssetSubNumber = [];
        this.ddlFilterAssetDesc1 = [];
        this.ddlFilterAssetNumbers = [];
        this.ddlFilterAssetDesc2 = [];
        this.ddlFilterVendorName = [];
        this.ddlFilterHierarchyProfillingID = [];
        this.ddlFilterHierarchyProfillingDesc = [];
        this.selectedCompanyCode = [];
        this.selectedAssetNumber = [];
        this.selectedAssetSubNumber = [];
        this.selectedAssetDesc1 = [];
        this.selectedAssetNumbers = [];
        this.selectedAssetDesc2 = [];
        this.selectedVendorName = [];
        this.selectedHierarchyProfillingID = [];
        this.selectedHierarchyProfillingDesc = [];
        this.selectedProjectCode = [];
        this.selectedProjectName = [];
        this.selectedValidFrom = '';
        this.selectedValidTo = '';
        // api companycode
        this.ddlCompanyCode = [];
        this.pageCompanyCode = 1;
        this.sizeCompanyCode = 10;
        this.mappingProfillingCompanyCodePaging = [];
        this.mappingProfillingCompanyCodeLoadPage = false;
        this.loadingCompanyCode = false;
        this.statusCompanyCode = '';
        this.statusMessageCompanyCode = '';
        // api vendor
        this.ddlVendorId = [];
        this.ddlVendorName = [];
        this.ddlVendorIDName = [];
        this.pageVendor = 1;
        this.sizeVendor = 10;
        this.descVendor = '';
        // api asset
        this.ddlAssetNumber = [];
        this.ddlAssetSubNumber = [];
        this.ddlAssetName1 = [];
        this.ddlAssetName2 = [];
        // api hierarchy
        this.mappingProfillingHierarchyProfillingList = [];
        this.ddlHierarchyProfillingId = [];
        this.ddlHierarchyProfillingDesc = [];
        this.selectedMappingProfillingModalHierarchyProfillingID = [];
        this.pageHierarchyProfilling = 1;
        this.sizeHierarchyProfilling = 10;
        this.descHierarchyProfilling = '';
        this.loadingHierarchyProfilling = false;
        this.mappingProfillingHierarchyProfillingPaging = [];
        this.mappingProfillingHierarchyProfillingLoadPage = false;
        this.statusHierarchyProfilling = '';
        this.statusMessageHierarchyProfilling = '';
        // isMappingViewDetail
        this.isMappingViewDetail = false;
        // selectedRadioHierarchyProfillingID
        this.selectedRadioHierarchyProfillingID = '';
        this.selectedRadioHierarchyProfillingDesc = '';
        // selected asset
        this.selectedMappingProfillingAssetNumber = [];
        // option create
        this.selectedCreateMappingSingle = 'false';
        this.selectedCreateMappingBulk = 'false';
        this.selectedUpdateMappingBulk = false;
        // vendor
        this.loadingVendor = false;
        this.mappingProfillingVendorPaging = [];
        this.mappingProfillingVendorLoadPage = false;
        this.mappingProfillingVendorList = [];
        this.selectedMappingProfillingVendorCode = [];
        // bulk upload temporary
        this.mappingProfillingListBulkTemporary = [];
        this.pageMappingProfillingBulkTemporary = 1;
        this.sizeMappingProfillingBulkTemporary = 10;
        this.loadingMappingBulkProfillingTemporary = false;
        this.mappingBulkProfillingTemporaryPaging = [];
        this.mappingProfillingBulkLoadPage = false;
        this.statusBulkTemporary = '';
        this.statusMessageBulkTemporary = '';
        this.selectedFileUpload = [];
        this.mappingProfillingListBulkReadyToUploaded = [];
        this.submitBulkstatus = '';
        this.submitBulkstatusMessage = '';
        this.uploadBulkStatus = '';
        this.uploadBulkStatusMessage = '';
        this.totalElementUploadBUlkError = 0;
        this.totalElementUploadBUlk = 0;
        this.pageFilter = 1;
        this.wasLoadQuickFilter = true;
        this.pageFilterCompanyCode = 1;
        this.wasLoadQuickFilterCompanyCode = true;
        this.descFilterCompanyCode = '';
        this.searchByFilterCompanyCode = '';
        this.pageFilterAsset = 1;
        this.wasLoadQuickFilterAsset = true;
        this.descFilterAsset = '';
        this.searchByFilterAsset = '';
        this.pageFilterVendor = 1;
        this.wasLoadQuickFilterVendor = true;
        this.descFilterVendor = '';
        this.searchByFilterVendor = '';
        this.pageFilterHierarchy = 1;
        this.wasLoadQuickFilterHierarchy = true;
        this.descFilterHierarchy = '';
        this.searchByFilterHierarchy = '';
        this.wasLoadQuickFilterMappingProject = true;
        this.descFilterMappingProject = '';
        this.searchByFilterMappingProject = '';
    }
    get getMappingProfillingWasFirstLoad() {
        return this.wasFirstLoad;
    }
    get getMappingProfillingAssetWasFirstLoad() {
        return this.wasAssetFirstLoad;
    }
    get getMappingProfillingVendorSize() {
        return this.sizeVendor;
    }
    get getResetMappingProfilling() {
        return this.resetMappingProfilling;
    }
    get getTotalElementUploadBUlkError() {
        return this.totalElementUploadBUlkError;
    }
    get getTotalElementUploadBUlk() {
        return this.totalElementUploadBUlk;
    }
    get getMappingProfillingListBulkReadyToUploaded() {
        return this.mappingProfillingListBulkReadyToUploaded;
    }
    get getMappingBulkProfillingTemporaryPaging() {
        return this.mappingBulkProfillingTemporaryPaging;
    }
    get getMappingProfillingListBulkTemporary() {
        return this.mappingProfillingListBulkTemporary;
    }
    get getMappingProfillingVendorLists() {
        return this.mappingProfillingVendorList;
    }
    get getMappingProfillingVendorPaging() {
        return this.mappingProfillingVendorPaging;
    }
    get getMappingProfillingLoading() {
        return this.loading;
    }
    get getMappingProfillingSize() {
        return this.size;
    }
    get getMappingProfillingDesc() {
        return this.desc;
    }
    get getMappingProfillingSearchBy() {
        return this.searchBy;
    }
    get getMappingProfillingStatus() {
        const status = {
            status: this.status,
            statusMessage: this.statusMessage
        };
        return status;
    }
    get getMappingProfillingLists() {
        return this.mappingProfillingList;
    }
    get getMappingProfillingPaging() {
        return this.mappingProfillingPaging;
    }
    get getDdlFilterCompanyCode() {
        return this.ddlFilterCompanyCode;
    }
    get getDdlFilterAssetNumber() {
        return this.ddlFilterAssetNumber;
    }
    get getDdlFilterAssetSubNumber() {
        return this.ddlFilterAssetSubNumber;
    }
    get getDdlFilterAssetDesc1() {
        return this.ddlFilterAssetDesc1;
    }
    get getDdlFilterAssetNumbers() {
        return this.ddlFilterAssetNumbers;
    }
    get getDdlFilterAssetDesc2() {
        return this.ddlFilterAssetDesc2;
    }
    get getDdlFilterVendorName() {
        return this.ddlFilterVendorName;
    }
    get getDdlFilterHierarchyProfillingID() {
        return this.ddlFilterHierarchyProfillingID;
    }
    get getDdlFilterHierarchyProfillingDesc() {
        return this.ddlFilterHierarchyProfillingDesc;
    }
    get getSelectedCompanyCode() {
        return this.selectedCompanyCode;
    }
    get getSelectedAssetSubNumber() {
        return this.selectedAssetSubNumber;
    }
    get getSelectedAssetDesc1() {
        return this.selectedAssetDesc1;
    }
    get getSelectedAssetNumbers() {
        return this.selectedAssetNumber;
    }
    get getSelectedAssetDesc2() {
        return this.selectedAssetDesc2;
    }
    get getSelectedVendorName() {
        return this.selectedVendorName;
    }
    get getSelectedHierarchyProfillingIDs() {
        return this.selectedHierarchyProfillingID;
    }
    get getSelectedHierarchyProfillingDescs() {
        return this.selectedHierarchyProfillingDesc;
    }
    get getSelectedProjectCode() {
        return this.selectedProjectCode;
    }
    get getSelectedProjectName() {
        return this.selectedProjectName;
    }
    get getSelectedValidFrom() {
        return this.selectedValidFrom;
    }
    get getSelectedValidTo() {
        return this.selectedValidTo;
    }
    get getMappingProfillingCompanyCodeLoading() {
        return this.loadingCompanyCode;
    }
    get getDdlVendorId() {
        return this.ddlVendorId;
    }
    get getDdlVendorName() {
        return this.ddlVendorName;
    }
    get getDdlVendorIDName() {
        return this.ddlVendorIDName;
    }
    get getDdlCompanyCode() {
        return this.ddlCompanyCode;
    }
    get getDdlAssetNumber() {
        return this.ddlAssetNumber;
    }
    get getDdlAssetSubNumber() {
        return this.ddlAssetSubNumber;
    }
    get getDdlAssetName1() {
        return this.ddlAssetName1;
    }
    get getDdlAssetName2() {
        return this.ddlAssetName2;
    }
    get getMappingProfillinghierarchyProfillingList() {
        return this.mappingProfillingHierarchyProfillingList;
    }
    get getDdlHierarchyProfillingId() {
        return this.ddlHierarchyProfillingId;
    }
    get getDdlHierarchyProfillingDesc() {
        return this.ddlHierarchyProfillingDesc;
    }
    get getMappingProfillingHierarchyPaging() {
        return this.mappingProfillingHierarchyProfillingPaging;
    }
    get getLoadingHierarchyProfilling() {
        return this.loadingHierarchyProfilling;
    }
    get getMappingProfillingHierarchyProfillingSize() {
        return this.sizeHierarchyProfilling;
    }
    get getMappingProfillingStatusHierarchyProfilling() {
        const status = {
            status: this.statusHierarchyProfilling,
            statusMessage: this.statusMessageHierarchyProfilling
        };
        return status;
    }
    get getIsMappingViewDetail() {
        return this.isMappingViewDetail;
    }
    get getSelectedRadioHierarchyProfillingID() {
        return this.selectedRadioHierarchyProfillingID;
    }
    get getSelectedRadioHierarchyProfillingDesc() {
        return this.selectedRadioHierarchyProfillingDesc;
    }
    get getSelectedOptionCreate() {
        return this.selectedCreateMappingSingle;
    }
    get getSelectedOptionCreateBulk() {
        return this.selectedCreateMappingBulk;
    }
    get getSelectedUpdateMappingBulk() {
        return this.selectedUpdateMappingBulk;
    }
    get getMappingProfillingBUlkStatus() {
        const status = {
            status: this.submitBulkstatus,
            statusMessage: this.submitBulkstatusMessage
        };
        return status;
    }
    get getSizeMappingProfillingBulkTemporary() {
        return this.sizeMappingProfillingBulkTemporary;
    }
    get getMappingProfillingWasLoadQuickFilter() {
        return this.wasLoadQuickFilter;
    }
    get getMappingProfillingWasLoadQuickFilterCompanyCode() {
        return this.wasLoadQuickFilterCompanyCode;
    }
    get getMappingProfillingWasLoadQuickFilterAsset() {
        return this.wasLoadQuickFilterAsset;
    }
    get getMappingProfillingWasLoadQuickFilterVendor() {
        return this.wasLoadQuickFilterVendor;
    }
    get getMappingProfillingWasLoadQuickFilterHierarchy() {
        return this.wasLoadQuickFilterHierarchy;
    }
    get getMappingProfillingWasLoadQuickFilterMappingProject() {
        return this.wasLoadQuickFilterMappingProject;
    }
    get getMappingProfillingAssetSearchBy() {
        return this.searchByFilterAsset;
    }
    get getMappingProfillingAssetDesc() {
        return this.descFilterAsset;
    }
    get getMappingProfillingVendorSearchBy() {
        return this.searchByFilterVendor;
    }
    get getMappingProfillingVendorDesc() {
        return this.descFilterVendor;
    }
    get getMappingProfillingHierarchySearchBy() {
        return this.searchByFilterHierarchy;
    }
    get getMappingProfillingHierarchyDesc() {
        return this.descFilterHierarchy;
    }
    [_a = Mutations.SET_MAPPING_PROFILLING_WAS_FIRST_LOAD](payload) {
        this.wasFirstLoad = payload;
    }
    [_b = Mutations.SET_MAPPING_PROFILLING_ASSET_WAS_FIRST_LOAD](payload) {
        this.wasAssetFirstLoad = payload;
    }
    [_c = Mutations.SET_SELECTED_MAPPING_PROFILLING_VENDORCODE](payload) {
        this.selectedMappingProfillingVendorCode = payload;
    }
    [_d = Mutations.SET_MAPPING_PROFILLING_VENDOR_HANDLE_PAGE](payload) {
        this.pageVendor = payload;
    }
    [_e = Mutations.SET_OPTION_CREATE_MAPPING_PROFILLING](payload) {
        return (this.selectedCreateMappingSingle = payload);
    }
    [_f = Mutations.SET_OPTION_CREATE_MAPPING_PROFILLING_BULK](payload) {
        return (this.selectedCreateMappingBulk = payload);
    }
    [_g = Mutations.SET_OPTION_UPDATE_MAPPING_PROFILLING_BULK]() {
        return (this.selectedUpdateMappingBulk = !this.selectedUpdateMappingBulk);
    }
    [_h = Mutations.SET_MAPPING_PROFILLING_LIST](payload) {
        this.mappingProfillingList = payload;
    }
    [_j = Mutations.SET_MAPPING_PROFILLING_LOADING](payload) {
        this.loading = payload;
    }
    [_k = Mutations.SET_MAPPING_PROFILLING_HANDLE_PAGE](payload) {
        this.page = payload;
    }
    [_l = Mutations.SET_MAPPING_PROFILLING_PAGE](payload) {
        this.mappingProfillingPaging = payload;
    }
    [_m = Mutations.SET_MAPPING_PROFILLING_LOAD_PAGE]() {
        this.loadPage = true;
    }
    [_o = Mutations.SET_MAPPING_PROFILLING_STATUS](payload) {
        this.status = payload.status;
        this.statusMessage = payload.message;
    }
    [_p = Mutations.SET_MAPPING_PROFILLING_SIZE](payload) {
        this.size = payload;
    }
    [_q = Mutations.SET_MAPPING_PROFILLING_FILTERDDL_COMPANYCODE](payload) {
        this.ddlFilterCompanyCode = payload;
    }
    [_r = Mutations.SET_MAPPING_PROFILLING_FILTERDDL_ASSETNUMBER](payload) {
        this.ddlFilterAssetNumber = payload;
    }
    [_s = Mutations.SET_MAPPING_PROFILLING_FILTERDDL_ASSETSUBNUMBER](payload) {
        this.ddlFilterAssetSubNumber = payload;
    }
    [_t = Mutations.SET_MAPPING_PROFILLING_FILTERDDL_ASSETDESC1](payload) {
        this.ddlFilterAssetDesc1 = payload;
    }
    [_u = Mutations.SET_MAPPING_PROFILLING_FILTERDDL_ASSETNUMBERS](payload) {
        this.ddlFilterAssetNumbers = payload;
    }
    [_v = Mutations.SET_MAPPING_PROFILLING_FILTERDDL_ASSETDESC2](payload) {
        this.ddlFilterAssetDesc2 = payload;
    }
    [_w = Mutations.SET_MAPPING_PROFILLING_FILTERDDL_VENDORNAME](payload) {
        this.ddlFilterVendorName = payload;
    }
    [_x = Mutations.SET_MAPPING_PROFILLING_FILTERDDL_HIERARCHY_PROFILLINGID](payload) {
        this.ddlFilterHierarchyProfillingID = payload;
    }
    [_y = Mutations.SET_MAPPING_PROFILLING_FILTERDDL_HIERARCHY_PROFILLINGDESC](payload) {
        this.ddlFilterHierarchyProfillingDesc = payload;
    }
    [_z = Mutations.SET_SELECTED_MAPPING_PROFILLING_COMPANYCODE](payload) {
        this.selectedCompanyCode = payload;
    }
    [_0 = Mutations.SET_MAPPING_PROFILLING_VENDOR_HANDLE_SIZE](payload) {
        this.sizeVendor = payload;
    }
    [_1 = Mutations.SET_SELECTED_MAPPING_PROFILLING_ASSETNUMBER](payload) {
        this.selectedAssetNumber = payload;
    }
    [_2 = Mutations.SET_SELECTED_MAPPING_PROFILLING_ASSETSUBNUMBER](payload) {
        this.selectedAssetSubNumber = payload;
    }
    [_3 = Mutations.SET_SELECTED_MAPPING_PROFILLING_ASSETDESC1](payload) {
        this.selectedAssetDesc1 = payload;
    }
    [_4 = Mutations.SET_SELECTED_MAPPING_PROFILLING_ASSETDESC2](payload) {
        this.selectedAssetDesc2 = payload;
    }
    [_5 = Mutations.SET_SELECTED_MAPPING_PROFILLING_VENDORNAME](payload) {
        this.selectedVendorName = payload;
    }
    [_6 = Mutations.SET_SELECTED_MAPPING_PROFILLING_HIERARCHY_PROFILLINGID](payload) {
        this.selectedHierarchyProfillingID = payload;
    }
    [_7 = Mutations.SET_SELECTED_MAPPING_PROFILLING_HIERARCHY_PROFILLINGDESC](payload) {
        this.selectedHierarchyProfillingDesc = payload;
    }
    [_8 = Mutations.SET_SELECTED_MAPPING_PROFILLING_PROJECT_CODE](payload) {
        this.selectedProjectCode = payload;
    }
    [_9 = Mutations.SET_SELECTED_MAPPING_PROFILLING_PROJECT_NAME](payload) {
        this.selectedProjectName = payload;
    }
    [_10 = Mutations.SET_SELECTED_MAPPING_PROFILLING_VALIDFROM](payload) {
        this.selectedValidFrom = payload;
    }
    [_11 = Mutations.SET_SELECTED_MAPPING_PROFILLING_VALIDTO](payload) {
        this.selectedValidTo = payload;
    }
    [_12 = Mutations.SET_MAPPING_PROFILLING_COMPANYCODE](payload) {
        this.ddlCompanyCode = payload;
    }
    [_13 = Mutations.SET_MAPPING_PROFILLING_COMPANYCODE_LOADING](payload) {
        this.loadingCompanyCode = payload;
    }
    [_14 = Mutations.SET_MAPPING_PROFILLING_COMPANYCODE_PAGE](payload) {
        this.mappingProfillingCompanyCodePaging = payload;
    }
    [_15 = Mutations.SET_MAPPING_PROFILLING_COMPANYCODE_STATUS](payload) {
        this.status = payload.statusCompanyCode;
        this.statusMessage = payload.statusMessageCompanyCode;
    }
    [_16 = Mutations.SET_MAPPING_PROFILLING_COMPANYCODE_LOAD_PAGE]() {
        this.mappingProfillingCompanyCodeLoadPage = true;
    }
    [_17 = Mutations.SET_MAPPING_PROFILLING_VENDORID](payload) {
        this.ddlVendorId = payload;
    }
    [_18 = Mutations.SET_MAPPING_PROFILLING_VENDORNAME](payload) {
        this.ddlVendorName = payload;
    }
    [_19 = Mutations.SET_MAPPING_PROFILLING_VENDORIDNAME](payload) {
        this.ddlVendorIDName = payload;
    }
    [_20 = Mutations.SET_MAPPING_PROFILLING_VENDOR_LOADING](payload) {
        this.loadingVendor = payload;
    }
    [_21 = Mutations.SET_MAPPING_PROFILLING_VENDOR_LOAD_PAGE]() {
        this.mappingProfillingVendorLoadPage = true;
    }
    [_22 = Mutations.SET_MAPPING_PROFILLING_VENDOR_PAGE](payload) {
        this.mappingProfillingVendorPaging = payload;
    }
    [_23 = Mutations.SET_MAPPING_PROFILLING_ASSET_NUMBER](payload) {
        this.ddlAssetNumber = payload;
    }
    [_24 = Mutations.SET_MAPPING_PROFILLING_ASSET_SUB_NUMBER](payload) {
        this.ddlAssetSubNumber = payload;
    }
    [_25 = Mutations.SET_MAPPING_PROFILLING_ASSET_NAME_1](payload) {
        this.ddlAssetName1 = payload;
    }
    [_26 = Mutations.SET_MAPPING_PROFILLING_ASSET_NAME_2](payload) {
        this.ddlAssetName2 = payload;
    }
    [_27 = Mutations.SET_MAPPING_PROFILLING_WAS_LOAD_QUICK_FILTER_ASSET](payload) {
        this.wasLoadQuickFilterAsset = payload;
    }
    [_28 = Mutations.SET_MAPPING_PROFILLING_PAGE_FILTER_ASSET](payload) {
        this.pageFilterAsset = payload;
    }
    [_29 = Mutations.SET_MAPPING_PROFILLING_HIERARCHY_PROFILLING_LIST](payload) {
        this.mappingProfillingHierarchyProfillingList = payload;
    }
    [_30 = Mutations.SET_MAPPING_PROFILLING_HIERARCHY_PROFILLINGID](payload) {
        this.ddlHierarchyProfillingId = payload;
    }
    [_31 = Mutations.SET_MAPPING_PROFILLING_HIERARCHY_PROFILLINGDESC](payload) {
        this.ddlHierarchyProfillingDesc = payload;
    }
    [_32 = Mutations.SET_SELECTED_MAPPING_PROFILLING_MODAL_HIERARCHY_PROFILLINGID](payload) {
        this.selectedMappingProfillingModalHierarchyProfillingID = payload;
    }
    [_33 = Mutations.SET_MAPPING_PROFILLING_HIERARCHY_PROFILLING_LOADING](payload) {
        this.loadingHierarchyProfilling = payload;
    }
    [_34 = Mutations.SET_MAPPING_PROFILLING_HIERARCHY_PROFILLING_HANDLE_PAGE](payload) {
        this.pageHierarchyProfilling = payload;
    }
    [_35 = Mutations.SET_MAPPING_PROFILLING_HIERARCHY_PROFILLING_PAGE](payload) {
        this.mappingProfillingHierarchyProfillingPaging = payload;
    }
    [_36 = Mutations.SET_MAPPING_PROFILLING_HIERARCHY_PROFILLING_LOAD_PAGE]() {
        this.mappingProfillingHierarchyProfillingLoadPage = true;
    }
    [_37 = Mutations.SET_MAPPING_PROFILLING_HIERARCHY_PROFILLING_STATUS](payload) {
        this.status = payload.statusHierarchyProfilling;
        this.statusMessage = payload.statusMessageHierarchyProfilling;
    }
    [_38 = Mutations.SET_MAPPING_PROFILLING_HIERARCHY_PROFILLING_SIZE](payload) {
        this.sizeHierarchyProfilling = payload;
    }
    [_39 = Mutations.SET_MAPPING_PROFILLING_USE_FILTER](payload) {
        this.useFilter = payload;
    }
    [_40 = Mutations.SET_MAPPING_PROFILLING_RESET](payload) {
        this.resetMappingProfilling = payload;
    }
    [_41 = Mutations.SET_MAPPING_PROFILLING_VIEWDETAIL](payload) {
        this.isMappingViewDetail = payload;
    }
    [_42 = Mutations.SET_SELECTEDRADIO_MAPPINGPORILLING_HIERARCHY_PROFILLINGID](payload) {
        this.selectedRadioHierarchyProfillingID = payload;
    }
    [_43 = Mutations.SET_SELECTEDRADIO_MAPPINGPORILLING_HIERARCHY_PROFILLINGDESC](payload) {
        this.selectedRadioHierarchyProfillingDesc = payload;
    }
    [_44 = Mutations.SET_MAPPING_PROFILLING_VENDOR_LIST](payload) {
        this.mappingProfillingVendorList = payload;
    }
    [_45 = Mutations.SET_MAPPING_PROFILLING_LISTBULK](payload) {
        this.mappingProfillingListBulkTemporary = payload;
    }
    [_46 = Mutations.SET_MAPPING_PROFILLING_LISTBULK_LOAD_PAGE]() {
        this.mappingProfillingBulkLoadPage = true;
    }
    [_47 = Mutations.SET_MAPPING_PROFILLING_LISTBULK_PAGE](payload) {
        this.mappingBulkProfillingTemporaryPaging = payload;
    }
    [_48 = Mutations.SET_MAPPING_PROFILLING_LISTBULK_LOADING](payload) {
        this.loadingMappingBulkProfillingTemporary = payload;
    }
    [_49 = Mutations.SET_MAPPING_PROFILLING_LISTBULK_HANDLE_PAGE](payload) {
        this.pageMappingProfillingBulkTemporary = payload;
    }
    [_50 = Mutations.SET_MAPPING_PROFILLING_LISTBULK_READYTOUPLOADED](payload) {
        this.mappingProfillingListBulkReadyToUploaded = payload;
    }
    [_51 = Mutations.SET_MAPPING_PROFILLING_SUBMITBULK_STATUS](payload) {
        this.submitBulkstatus = payload.status;
        this.submitBulkstatusMessage = payload.message;
    }
    [_52 = Mutations.SET_MAPPING_PROFILLING_SELECTED_SEARCH_BY](payload) {
        this.searchBy = payload;
    }
    [_53 = Mutations.SET_TOTALELEMENT_BULK_ERRORUPLOAD](payload) {
        this.totalElementUploadBUlkError = payload;
    }
    [_54 = Mutations.SET_TOTALELEMENT_BULK_UPLOAD](payload) {
        this.totalElementUploadBUlk = payload;
    }
    [_55 = Mutations.SET_MAPPING_PROFILLING_LISTBULK_STATUS](payload) {
        this.uploadBulkStatus = payload.status;
        this.uploadBulkStatusMessage = payload.message;
    }
    [_56 = Mutations.SET_MAPPING_PROFILLING_VENDOR_SIZE](payload) {
        this.sizeVendor = payload;
    }
    [_57 = Mutations.SET_MAPPING_PROFILLING_BULK_TEMP_SIZE](payload) {
        this.sizeMappingProfillingBulkTemporary = payload;
    }
    [_58 = Mutations.SET_MAPPING_PROFILLING_PAGE_FILTER](payload) {
        this.pageFilter = payload;
    }
    [_59 = Mutations.SET_MAPPING_PROFILLING_WAS_LOAD_QUICK_FILTER](payload) {
        this.wasLoadQuickFilter = payload;
    }
    [_60 = Mutations.SET_MAPPING_PROFILLING_PAGE_FILTER_COMPANY_CODE](payload) {
        this.pageFilterCompanyCode = payload;
    }
    [_61 = Mutations.SET_MAPPING_PROFILLING_WAS_LOAD_QUICK_FILTER_COMPANY_CODE](payload) {
        this.wasLoadQuickFilterCompanyCode = payload;
    }
    [_62 = Mutations.SET_MAPPING_PROFILLING_PAGE_FILTER_VENDOR](payload) {
        this.pageFilterVendor = payload;
    }
    [_63 = Mutations.SET_MAPPING_PROFILLING_WAS_LOAD_QUICK_FILTER_VENDOR](payload) {
        this.wasLoadQuickFilterVendor = payload;
    }
    [_64 = Mutations.SET_MAPPING_PROFILLING_PAGE_FILTER_HIERARCHY](payload) {
        this.pageFilterHierarchy = payload;
    }
    [_65 = Mutations.SET_MAPPING_PROFILLING_WAS_LOAD_QUICK_FILTER_HIERARCHY](payload) {
        this.wasLoadQuickFilterHierarchy = payload;
    }
    [_66 = Mutations.SET_MAPPING_PROFILLING_WAS_LOAD_QUICK_FILTER_MAPPING_PROJECT](payload) {
        this.wasLoadQuickFilterMappingProject = payload;
    }
    [_67 = Mutations.SET_MAPPING_PROFILLING_SELECTED_DESC](payload) {
        this.desc = payload;
    }
    [_68 = Mutations.SET_MAPPING_PROFILLING_ASSET_DESC](payload) {
        this.descFilterAsset = payload;
    }
    [_69 = Mutations.SET_MAPPING_PROFILLING_ASSET_SEARCH_BY](payload) {
        this.searchByFilterAsset = payload;
    }
    [_70 = Mutations.SET_MAPPING_PROFILLING_VENDOR_DESC](payload) {
        this.descFilterVendor = payload;
    }
    [_71 = Mutations.SET_MAPPING_PROFILLING_VENDOR_SEARCH_BY](payload) {
        this.searchByFilterVendor = payload;
    }
    [_72 = Mutations.SET_MAPPING_PROFILLING_HIERARCHY_DESC](payload) {
        this.descFilterHierarchy = payload;
    }
    [_73 = Mutations.SET_MAPPING_PROFILLING_HIERARCHY_SEARCH_BY](payload) {
        this.searchByFilterHierarchy = payload;
    }
    [_74 = Actions.GET_MAPPING_PROFILLING_LIST]() {
        return __awaiter(this, void 0, void 0, function* () {
            this.context.commit(Mutations.SET_MAPPING_PROFILLING_LOADING, true);
            const url = process.env.VUE_APP_BASE_URL_DIGITAL +
                `/fincapex/api/master/mappingprofilling`;
            const params = {
                ver: 'v1',
                Page: this.page.toString(),
                Size: this.size.toString(),
                Desc: this.desc
            };
            return new Promise((resolve, reject) => {
                ApiService.get(url, '', new URLSearchParams(params).toString())
                    .then((res) => {
                    if (res.status === 200) {
                        this.context.commit(Mutations.SET_MAPPING_PROFILLING_LIST, res.data.result.content.data);
                        this.context.commit(Mutations.SET_MAPPING_PROFILLING_LOAD_PAGE, true);
                        this.context.commit(Mutations.SET_MAPPING_PROFILLING_PAGE, res.data.result.content.paging);
                        this.context.commit(Mutations.SET_MAPPING_PROFILLING_LOADING, false);
                        resolve(true);
                    }
                    else {
                        this.context.commit(Mutations.SET_MAPPING_PROFILLING_LOADING, false);
                        reject(false);
                    }
                })
                    .catch((err) => {
                    this.context.commit(Mutations.SET_MAPPING_PROFILLING_LOADING, false);
                    reject(false);
                });
            });
        });
    }
    [_75 = Actions.GET_MAPPING_PROFILLING_LIST_POPULATEDDLFILTER]() {
        return __awaiter(this, void 0, void 0, function* () {
            this.context.commit(Mutations.SET_MAPPING_PROFILLING_WAS_LOAD_QUICK_FILTER, false);
            const params = {
                ver: 'v1'
            };
            const url = process.env.VUE_APP_BASE_URL_DIGITAL +
                `/fincapex/api/master/mappingprofilling/filter?` +
                new URLSearchParams(params).toString();
            const paramsData = {
                Page: this.pageFilter.toString(),
                Size: '10',
                Desc: this.desc.toString(),
                SearchBy: this.searchBy.toString() // this.desc
            };
            const dataCompanyCode = [...this.ddlFilterCompanyCode];
            const dataAssetNumber = [...this.ddlFilterAssetNumber];
            const dataAssetSubNumber = [...this.ddlFilterAssetSubNumber];
            const dataAssetDesc1 = [...this.ddlFilterAssetDesc1];
            const dataAssetDesc2 = [...this.ddlFilterAssetDesc2];
            const dataVendorName = [...this.ddlFilterVendorName];
            const dataHierarchyProfillingID = [
                ...this.ddlFilterHierarchyProfillingID
            ];
            const dataHierarchyProfillingDesc = [
                ...this.ddlFilterHierarchyProfillingDesc
            ];
            return new Promise((resolve, reject) => {
                ApiService.post(url, paramsData)
                    .then((res) => {
                    if (res.status === 200) {
                        if (res.data.result.content.paging.totalPages === this.pageFilter) {
                            this.context.commit(Mutations.SET_MAPPING_PROFILLING_WAS_LOAD_QUICK_FILTER, false);
                        }
                        else {
                            this.context.commit(Mutations.SET_MAPPING_PROFILLING_WAS_LOAD_QUICK_FILTER, true);
                        }
                        res.data.result.content.data.map((data) => {
                            dataCompanyCode.push({
                                value: data.companyCode,
                                label: data.companyCode
                            });
                            dataAssetNumber.push({
                                value: data.assetNumber,
                                label: data.assetNumber
                            });
                            dataAssetSubNumber.push({
                                value: data.assetSubNumber,
                                label: data.assetSubNumber
                            });
                            dataAssetDesc1.push({
                                value: data.assetDesc1,
                                label: data.assetDesc1
                            });
                            dataAssetDesc2.push({
                                value: data.assetDesc2,
                                label: data.assetDesc2
                            });
                            dataVendorName.push({
                                value: data.vendorName,
                                label: data.vendorName
                            });
                            dataHierarchyProfillingID.push({
                                value: data.hierarchyProfillingID,
                                label: data.hierarchyProfillingID
                            });
                            dataHierarchyProfillingDesc.push({
                                value: data.hierarchyProfillingDesc,
                                label: data.hierarchyProfillingDesc
                            });
                        });
                        const distinctCompanyCode = Array.from(new Set(dataCompanyCode.map((s) => {
                            return s.value;
                        }))).map((label) => {
                            return {
                                value: label,
                                label: dataCompanyCode.find((s) => s.label === label).label
                            };
                        });
                        const distinctAssetNumber = Array.from(new Set(dataAssetNumber.map((s) => {
                            return s.value;
                        }))).map((label) => {
                            return {
                                value: label,
                                // eslint-disable-next-line arrow-body-style
                                label: dataAssetNumber.find((s) => s.label === label).label
                            };
                        });
                        // eslint-disable-next-line arrow-body-style
                        const distinctAssetSubNumber = Array.from(new Set(dataAssetSubNumber.map((s) => {
                            return s.value;
                        })))
                            // eslint-disable-next-line arrow-parens
                            .map((label) => {
                            return {
                                value: label,
                                // eslint-disable-next-line arrow-body-style
                                label: dataAssetSubNumber.find((s) => s.label === label).label
                            };
                        });
                        // eslint-disable-next-line arrow-body-style
                        const distinctAssetDesc1 = Array.from(new Set(dataAssetDesc1.map((s) => {
                            return s.value;
                        })))
                            // eslint-disable-next-line arrow-parens
                            .map((label) => {
                            return {
                                value: label,
                                // eslint-disable-next-line arrow-body-style
                                label: dataAssetDesc1.find((s) => s.label === label).label
                            };
                        });
                        // eslint-disable-next-line arrow-body-style
                        const distinctAssetDesc2 = Array.from(new Set(dataAssetDesc2.map((s) => {
                            return s.value;
                        })))
                            // eslint-disable-next-line arrow-parens
                            .map((label) => {
                            return {
                                value: label,
                                // eslint-disable-next-line arrow-body-style
                                label: dataAssetDesc2.find((s) => s.label === label).label
                            };
                        });
                        // eslint-disable-next-line arrow-body-style
                        const distinctVendorName = Array.from(new Set(dataVendorName.map((s) => {
                            return s.value;
                        })))
                            // eslint-disable-next-line arrow-parens
                            .map((label) => {
                            return {
                                value: label,
                                // eslint-disable-next-line arrow-body-style
                                label: dataVendorName.find((s) => s.label === label).label
                            };
                        });
                        // eslint-disable-next-line arrow-body-style
                        const distinctHierarchyProfillingID = Array.from(new Set(dataHierarchyProfillingID.map((s) => {
                            return s.value;
                        })))
                            // eslint-disable-next-line arrow-parens
                            .map((label) => {
                            return {
                                value: label,
                                // eslint-disable-next-line arrow-body-style
                                label: dataHierarchyProfillingID.find((s) => {
                                    return s.label === label;
                                }).label
                            };
                        });
                        // eslint-disable-next-line arrow-body-style
                        const distinctHierarchyProfillingDesc = Array.from(new Set(dataHierarchyProfillingDesc.map((s) => {
                            return s.value;
                        })))
                            // eslint-disable-next-line arrow-parens
                            .map((label) => {
                            return {
                                value: label,
                                // eslint-disable-next-line arrow-body-style
                                label: dataHierarchyProfillingDesc.find((s) => {
                                    return s.label === label;
                                }).label
                            };
                        });
                        this.context.commit(Mutations.SET_MAPPING_PROFILLING_FILTERDDL_COMPANYCODE, distinctCompanyCode);
                        this.context.commit(Mutations.SET_MAPPING_PROFILLING_FILTERDDL_ASSETNUMBER, distinctAssetNumber);
                        this.context.commit(Mutations.SET_MAPPING_PROFILLING_FILTERDDL_ASSETSUBNUMBER, distinctAssetSubNumber);
                        this.context.commit(Mutations.SET_MAPPING_PROFILLING_FILTERDDL_ASSETDESC1, distinctAssetDesc1);
                        this.context.commit(Mutations.SET_MAPPING_PROFILLING_FILTERDDL_ASSETNUMBERS, distinctAssetNumber);
                        this.context.commit(Mutations.SET_MAPPING_PROFILLING_FILTERDDL_ASSETDESC2, distinctAssetDesc2);
                        this.context.commit(Mutations.SET_MAPPING_PROFILLING_FILTERDDL_VENDORNAME, distinctVendorName);
                        this.context.commit(Mutations.SET_MAPPING_PROFILLING_FILTERDDL_HIERARCHY_PROFILLINGID, distinctHierarchyProfillingID);
                        this.context.commit(Mutations.SET_MAPPING_PROFILLING_FILTERDDL_HIERARCHY_PROFILLINGDESC, distinctHierarchyProfillingDesc);
                        resolve(true);
                    }
                    else {
                        this.context.commit(Mutations.SET_MAPPING_PROFILLING_WAS_LOAD_QUICK_FILTER, true);
                        reject(false);
                    }
                })
                    .catch((err) => {
                    this.context.commit(Mutations.SET_MAPPING_PROFILLING_WAS_LOAD_QUICK_FILTER, true);
                    reject(false);
                });
            });
        });
    }
    [_76 = Actions.UPDATE_MAPPING_PROFILLING_PAGE_FILTER]() {
        return __awaiter(this, void 0, void 0, function* () {
            this.context.commit(Mutations.SET_MAPPING_PROFILLING_PAGE_FILTER, this.pageFilter + 1);
        });
    }
    [_77 = Actions.UPDATE_MAPPING_PROFILLING_PAGE_FILTER_COMPANY_CODE]() {
        return __awaiter(this, void 0, void 0, function* () {
            this.context.commit(Mutations.SET_MAPPING_PROFILLING_PAGE_FILTER_COMPANY_CODE, this.pageFilterCompanyCode + 1);
        });
    }
    [_78 = Actions.UPDATE_MAPPING_PROFILLING_PAGE_FILTER_ASSET]() {
        return __awaiter(this, void 0, void 0, function* () {
            this.context.commit(Mutations.SET_MAPPING_PROFILLING_PAGE_FILTER_ASSET, this.pageFilterAsset + 1);
        });
    }
    [_79 = Actions.UPDATE_MAPPING_PROFILLING_PAGE_FILTER_VENDOR]() {
        return __awaiter(this, void 0, void 0, function* () {
            this.context.commit(Mutations.SET_MAPPING_PROFILLING_PAGE_FILTER_VENDOR, this.pageFilterVendor + 1);
        });
    }
    [_80 = Actions.UPDATE_MAPPING_PROFILLING_PAGE_FILTER_HIERARCHY]() {
        return __awaiter(this, void 0, void 0, function* () {
            this.context.commit(Mutations.SET_MAPPING_PROFILLING_PAGE_FILTER_HIERARCHY, this.pageFilterHierarchy + 1);
        });
    }
    [_81 = Actions.GET_MAPPING_PROFILLING_DATA]() {
        return __awaiter(this, void 0, void 0, function* () {
            if (!this.useFilter) {
                this.context.dispatch(Actions.GET_MAPPING_PROFILLING_LIST);
            }
            else {
                this.context.dispatch(Actions.GET_MAPPING_PROFILLING_LIST_FILTER, {
                    Page: this.page.toString(),
                    Size: this.size.toString(),
                    Desc: '',
                    SearchBy: '',
                    companyCode: this.selectedCompanyCode,
                    assetNumber: this.selectedAssetNumber,
                    assetSubNumber: this.selectedAssetSubNumber,
                    assetDesc1: this.selectedAssetDesc1,
                    assetDesc2: this.selectedAssetDesc2,
                    vendorName: this.selectedVendorName,
                    hierarchyProfillingID: this.selectedHierarchyProfillingID,
                    hierarchyProfillingDesc: this.selectedHierarchyProfillingDesc,
                    projectCode: this.selectedProjectCode,
                    projectDescription: this.selectedProjectName,
                    validFrom: this.selectedValidFrom,
                    validTo: this.selectedValidTo
                });
            }
        });
    }
    [_82 = Actions.GET_MAPPING_PROFILLING_LIST_FILTER](data) {
        return __awaiter(this, void 0, void 0, function* () {
            this.context.commit(Mutations.SET_MAPPING_PROFILLING_LOADING, true);
            this.context.commit(Mutations.SET_SELECTED_MAPPING_PROFILLING_COMPANYCODE, data.companyCode);
            this.context.commit(Mutations.SET_SELECTED_MAPPING_PROFILLING_ASSETNUMBER, data.assetNumber);
            this.context.commit(Mutations.SET_SELECTED_MAPPING_PROFILLING_ASSETSUBNUMBER, data.assetSubNumber);
            this.context.commit(Mutations.SET_SELECTED_MAPPING_PROFILLING_ASSETDESC1, data.assetDesc1);
            this.context.commit(Mutations.SET_SELECTED_MAPPING_PROFILLING_ASSETDESC2, data.assetDesc2);
            this.context.commit(Mutations.SET_SELECTED_MAPPING_PROFILLING_VENDORNAME, data.vendorName);
            this.context.commit(Mutations.SET_SELECTED_MAPPING_PROFILLING_HIERARCHY_PROFILLINGID, data.hierarchyProfillingID);
            this.context.commit(Mutations.SET_SELECTED_MAPPING_PROFILLING_HIERARCHY_PROFILLINGDESC, data.hierarchyProfillingDesc);
            this.context.commit(Mutations.SET_SELECTED_MAPPING_PROFILLING_PROJECT_CODE, data.projectCode);
            this.context.commit(Mutations.SET_SELECTED_MAPPING_PROFILLING_PROJECT_NAME, data.projectDesc);
            this.context.commit(Mutations.SET_SELECTED_MAPPING_PROFILLING_VALIDFROM, data.validFrom);
            this.context.commit(Mutations.SET_SELECTED_MAPPING_PROFILLING_VALIDTO, data.validTo);
            const params = {
                ver: 'v1'
            };
            const url = process.env.VUE_APP_BASE_URL_DIGITAL +
                `/fincapex/api/master/mappingprofilling/filter?` +
                new URLSearchParams(params).toString();
            const paramsData = {
                Page: this.page.toString(),
                Size: this.size.toString(),
                Desc: '',
                SearchBy: '',
                companyCode: data.companyCode,
                assetNumber: data.assetNumber,
                assetSubNumber: data.assetSubNumber,
                assetDesc1: data.assetDesc1,
                assetDesc2: data.assetDesc2,
                vendorCode: data.vendorName,
                hierarchyProfillingID: data.hierarchyProfillingID,
                hierarchyProfillingDesc: data.hierarchyProfillingDesc,
                projectCode: data.projectCode,
                projectDescription: data.projectDesc,
                validFrom: data.validFrom,
                validTo: data.validTo
            };
            return new Promise((resolve, reject) => {
                ApiService.post(url, paramsData)
                    .then((res) => {
                    var _115, _116;
                    if (res.status === 200) {
                        this.context.commit(Mutations.SET_MAPPING_PROFILLING_LIST, ((_115 = res.data.result.content) === null || _115 === void 0 ? void 0 : _115.data) || []);
                        this.context.commit(Mutations.SET_MAPPING_PROFILLING_PAGE, ((_116 = res.data.result.content) === null || _116 === void 0 ? void 0 : _116.paging) || {
                            currentPage: 0,
                            totalPages: 0,
                            totalElements: 0,
                            errorRows: 0,
                            readyToUpload: 0
                        });
                        if (!this.loadPage) {
                            this.context.commit(Mutations.SET_MAPPING_PROFILLING_LOAD_PAGE, true);
                        }
                        this.context.commit(Mutations.SET_MAPPING_PROFILLING_LOADING, false);
                        resolve(true);
                    }
                    else {
                        reject(false);
                    }
                })
                    .catch((err) => {
                    reject(false);
                });
            });
        });
    }
    [_83 = Actions.GET_MAPPING_PROFILLING_COMPANYCODE_LIST]() {
        return __awaiter(this, void 0, void 0, function* () {
            this.context.commit(Mutations.SET_MAPPING_PROFILLING_WAS_LOAD_QUICK_FILTER_COMPANY_CODE, false);
            this.context.commit(Mutations.SET_MAPPING_PROFILLING_COMPANYCODE_LOADING, false);
            const url = process.env.VUE_APP_BASE_URL_DIGITAL +
                `/fincapex/api/master/mappingprofilling/companycode`;
            const params = {
                ver: 'v1',
                Page: this.pageFilterCompanyCode.toString(),
                Size: '10',
                Desc: this.desc
            };
            const dataListCompanyCode = [...this.ddlCompanyCode];
            return new Promise((resolve, reject) => {
                ApiService.get(url, '', new URLSearchParams(params).toString())
                    .then((res) => {
                    if (res.status === 200) {
                        if (res.data.result.content.paging.totalPages === this.pageFilter) {
                            this.context.commit(Mutations.SET_MAPPING_PROFILLING_WAS_LOAD_QUICK_FILTER_COMPANY_CODE, false);
                        }
                        else {
                            this.context.commit(Mutations.SET_MAPPING_PROFILLING_WAS_LOAD_QUICK_FILTER_COMPANY_CODE, true);
                        }
                        res.data.result.content.data.map((data) => {
                            dataListCompanyCode.push({
                                value: data.companyCode,
                                label: data.companyCode
                            });
                        });
                        this.context.commit(Mutations.SET_MAPPING_PROFILLING_COMPANYCODE, dataListCompanyCode);
                        this.context.commit(Mutations.SET_MAPPING_PROFILLING_COMPANYCODE_LOAD_PAGE, true);
                        this.context.commit(Mutations.SET_MAPPING_PROFILLING_COMPANYCODE_PAGE, res.data.result.content.paging);
                        this.context.commit(Mutations.SET_MAPPING_PROFILLING_COMPANYCODE_LOADING, false);
                        resolve(true);
                    }
                    else {
                        this.context.commit(Mutations.SET_MAPPING_PROFILLING_COMPANYCODE_LOADING, false);
                        this.context.commit(Mutations.SET_MAPPING_PROFILLING_WAS_LOAD_QUICK_FILTER_COMPANY_CODE, false);
                        reject(false);
                    }
                })
                    .catch((err) => {
                    this.context.commit(Mutations.SET_MAPPING_PROFILLING_COMPANYCODE_LOADING, false);
                    this.context.commit(Mutations.SET_MAPPING_PROFILLING_WAS_LOAD_QUICK_FILTER_COMPANY_CODE, false);
                    reject(false);
                });
            });
        });
    }
    [_84 = Actions.GET_MAPPING_PROFILLING_VENDOR_LISTALLDATA]() {
        return __awaiter(this, void 0, void 0, function* () {
            this.context.commit(Mutations.SET_MAPPING_PROFILLING_WAS_LOAD_QUICK_FILTER_VENDOR, false);
            const params = {
                ver: 'v1'
            };
            const url = process.env.VUE_APP_BASE_URL_DIGITAL +
                `/fincapex/api/master/vendor/filter?` +
                new URLSearchParams(params).toString();
            const paramsData = {
                Page: this.pageFilterVendor.toString(),
                Size: '10',
                Desc: this.descFilterVendor.toString(),
                SearchBy: this.searchByFilterVendor.toString()
            };
            const dataListVendor = [...this.ddlVendorIDName];
            const dataListVendorCode = [...this.ddlVendorId];
            const dataListVendorName = [...this.ddlVendorName];
            return new Promise((resolve, reject) => {
                ApiService.post(url, paramsData)
                    .then((res) => {
                    if (res.status === 200) {
                        if (res.data.result.content.paging.totalPages === this.pageFilter) {
                            this.context.commit(Mutations.SET_MAPPING_PROFILLING_WAS_LOAD_QUICK_FILTER_VENDOR, false);
                        }
                        else {
                            this.context.commit(Mutations.SET_MAPPING_PROFILLING_WAS_LOAD_QUICK_FILTER_VENDOR, true);
                        }
                        res.data.result.content.data.map((data) => {
                            dataListVendorCode.push({
                                value: data.vendorCode,
                                label: data.vendorCode
                            });
                            dataListVendorName.push({
                                value: data.vendorName,
                                label: data.vendorName
                            });
                            dataListVendor.push({
                                value: data.vendorCode,
                                label: data.vendorName
                            });
                        });
                        this.context.commit(Mutations.SET_MAPPING_PROFILLING_VENDORID, dataListVendorCode);
                        this.context.commit(Mutations.SET_MAPPING_PROFILLING_VENDORNAME, dataListVendorName);
                        this.context.commit(Mutations.SET_MAPPING_PROFILLING_VENDORIDNAME, dataListVendor);
                        resolve(true);
                    }
                    else {
                        // this.context.commit(Mutations.SET_MAPPING_PROFILLING_VENDORNAME_LOADING, false);
                        this.context.commit(Mutations.SET_MAPPING_PROFILLING_WAS_LOAD_QUICK_FILTER_VENDOR, false);
                        reject(false);
                    }
                })
                    .catch((err) => {
                    // this.context.commit(Mutations.SET_MAPPING_PROFILLING_VENDORNAME_LOADING, false);
                    this.context.commit(Mutations.SET_MAPPING_PROFILLING_WAS_LOAD_QUICK_FILTER_VENDOR, false);
                    reject(false);
                });
            });
        });
    }
    [_85 = Actions.GET_MAPPING_PROFILLING_HIERARCHY_ASSET_LISTALLDATA]() {
        return __awaiter(this, void 0, void 0, function* () {
            this.context.commit(Mutations.SET_MAPPING_PROFILLING_WAS_LOAD_QUICK_FILTER_ASSET, false);
            const params = {
                ver: 'v1'
            };
            const url = process.env.VUE_APP_BASE_URL_DIGITAL +
                `/fincapex/api/master/asset/filter?` +
                new URLSearchParams(params).toString();
            const dataListAssetNumber = [...this.ddlAssetNumber];
            const dataListAssetSubNumber = [...this.ddlAssetSubNumber];
            const dataListAssetName1 = [...this.ddlAssetName1];
            const dataListAssetName2 = [...this.ddlAssetName2];
            const paramsData = {
                Page: this.pageFilterAsset.toString(),
                Size: '9999',
                Desc: this.descFilterAsset.toString(),
                SearchBy: this.searchByFilterAsset.toString() // this.searchByFilterAsset
            };
            return new Promise((resolve, reject) => {
                ApiService.post(url, paramsData)
                    .then((res) => {
                    if (res.status === 200) {
                        if (res.data.result.content !== null) {
                            if (res.data.result.content.paging.totalPages === this.pageFilter) {
                                this.context.commit(Mutations.SET_MAPPING_PROFILLING_WAS_LOAD_QUICK_FILTER_ASSET, false);
                            }
                            else {
                                this.context.commit(Mutations.SET_MAPPING_PROFILLING_WAS_LOAD_QUICK_FILTER_ASSET, true);
                            }
                            res.data.result.content.data.map((data) => {
                                if (dataListAssetNumber.length === 0) {
                                    dataListAssetNumber.push({
                                        value: data.assetNumber,
                                        label: data.assetNumber
                                    });
                                }
                                else {
                                    const findId = dataListAssetNumber.find((element) => {
                                        return element.value === data.assetNumber;
                                    });
                                    if (findId === undefined) {
                                        dataListAssetNumber.push({
                                            value: data.assetNumber,
                                            label: data.assetNumber
                                        });
                                    }
                                }
                                if (dataListAssetSubNumber.length === 0) {
                                    dataListAssetSubNumber.push({
                                        value: data.assetSubNumber,
                                        label: data.assetSubNumber
                                    });
                                }
                                else {
                                    const findId = dataListAssetSubNumber.find((element) => {
                                        return element.value === data.assetSubNumber;
                                    });
                                    if (findId === undefined) {
                                        dataListAssetSubNumber.push({
                                            value: data.assetSubNumber,
                                            label: data.assetSubNumber
                                        });
                                    }
                                }
                                if (dataListAssetName1.length === 0) {
                                    dataListAssetName1.push({
                                        value: data.assetDesc1,
                                        label: data.assetDesc1
                                    });
                                }
                                else {
                                    const findId = dataListAssetName1.find((element) => {
                                        return element.value === data.assetDesc1;
                                    });
                                    if (findId === undefined) {
                                        dataListAssetName1.push({
                                            value: data.assetDesc1,
                                            label: data.assetDesc1
                                        });
                                    }
                                }
                                if (dataListAssetName2.length === 0) {
                                    dataListAssetName2.push({
                                        value: data.assetDesc2,
                                        label: data.assetDesc2
                                    });
                                }
                                else {
                                    const findId = dataListAssetName2.find((element) => {
                                        return element.value === data.assetDesc2;
                                    });
                                    if (findId === undefined) {
                                        dataListAssetName2.push({
                                            value: data.assetDesc2,
                                            label: data.assetDesc2
                                        });
                                    }
                                }
                            });
                        }
                        else {
                            this.context.commit(Mutations.SET_MAPPING_PROFILLING_WAS_LOAD_QUICK_FILTER_ASSET, false);
                        }
                        this.context.commit(Mutations.SET_MAPPING_PROFILLING_ASSET_NUMBER, dataListAssetNumber);
                        this.context.commit(Mutations.SET_MAPPING_PROFILLING_ASSET_SUB_NUMBER, dataListAssetSubNumber);
                        this.context.commit(Mutations.SET_MAPPING_PROFILLING_ASSET_NAME_1, dataListAssetName1);
                        this.context.commit(Mutations.SET_MAPPING_PROFILLING_ASSET_NAME_2, dataListAssetName2);
                        resolve(true);
                    }
                    else {
                        // this.context.commit(Mutations.SET_MAPPING_PROFILLING_VENDORNAME_LOADING, false);
                        this.context.commit(Mutations.SET_MAPPING_PROFILLING_WAS_LOAD_QUICK_FILTER_ASSET, false);
                        reject(false);
                    }
                })
                    .catch((err) => {
                    // this.context.commit(Mutations.SET_MAPPING_PROFILLING_VENDORNAME_LOADING, false);
                    this.context.commit(Mutations.SET_MAPPING_PROFILLING_WAS_LOAD_QUICK_FILTER_ASSET, false);
                    reject(false);
                });
            });
        });
    }
    [_86 = Actions.GET_MAPPING_PROFILLING_VENDOR_LIST]() {
        return __awaiter(this, void 0, void 0, function* () {
            this.context.commit(Mutations.SET_MAPPING_PROFILLING_VENDOR_LOADING, false);
            const params = {
                ver: 'v1'
            };
            const url = process.env.VUE_APP_BASE_URL_DIGITAL +
                `/fincapex/api/master/vendor/filter?` +
                new URLSearchParams(params).toString();
            const paramsData = {
                Page: this.pageVendor.toString(),
                Size: this.sizeVendor.toString(),
                vendorCode: this.selectedMappingProfillingVendorCode
            };
            return new Promise((resolve, reject) => {
                ApiService.post(url, paramsData)
                    .then((res) => {
                    if (res.status === 200) {
                        this.context.commit(Mutations.SET_MAPPING_PROFILLING_VENDOR_LIST, res.data.result.content.data);
                        this.context.commit(Mutations.SET_MAPPING_PROFILLING_VENDOR_LOAD_PAGE, true);
                        this.context.commit(Mutations.SET_MAPPING_PROFILLING_VENDOR_PAGE, res.data.result.content.paging);
                        this.context.commit(Mutations.SET_MAPPING_PROFILLING_VENDOR_LOADING, false);
                        resolve(true);
                    }
                    else {
                        this.context.commit(Mutations.SET_MAPPING_PROFILLING_VENDOR_LOADING, false);
                        reject(false);
                    }
                })
                    .catch((err) => {
                    this.context.commit(Mutations.SET_MAPPING_PROFILLING_VENDOR_LOADING, false);
                    reject(false);
                });
            });
        });
    }
    [_87 = Actions.GET_MAPPING_PROFILLING_HIERARCHY_PROFILLING]() {
        return __awaiter(this, void 0, void 0, function* () {
            this.context.commit(Mutations.SET_MAPPING_PROFILLING_HIERARCHY_PROFILLING_LOADING, false);
            const params = {
                ver: 'v1'
            };
            const url = process.env.VUE_APP_BASE_URL_DIGITAL +
                `/fincapex/api/master/hierarchyprofilling/filter?` +
                new URLSearchParams(params).toString();
            const paramsData = {
                Page: this.pageHierarchyProfilling.toString(),
                Size: this.sizeHierarchyProfilling.toString(),
                // Desc: this.desc,
                isActive: true,
                hierarchyProfillingID: this.selectedMappingProfillingModalHierarchyProfillingID
            };
            const dataId = [];
            const dataDesc = [];
            return new Promise((resolve, reject) => {
                ApiService.post(url, paramsData)
                    .then((res) => {
                    if (res.status === 200) {
                        res.data.result.content.data.map((data) => {
                            dataId.push({
                                value: data.hierarchyProfillingId,
                                label: data.hierarchyProfillingId
                            });
                            dataDesc.push({
                                value: data.hierarchyProfillingDesc,
                                label: data.hierarchyProfillingDesc
                            });
                        });
                        this.context.commit(Mutations.SET_MAPPING_PROFILLING_HIERARCHY_PROFILLING_LIST, res.data.result.content.data);
                        this.context.commit(Mutations.SET_MAPPING_PROFILLING_HIERARCHY_PROFILLING_LOAD_PAGE, true);
                        this.context.commit(Mutations.SET_MAPPING_PROFILLING_HIERARCHY_PROFILLING_PAGE, res.data.result.content.paging);
                        this.context.commit(Mutations.SET_MAPPING_PROFILLING_HIERARCHY_PROFILLING_LOADING, false);
                        resolve(true);
                    }
                    else {
                        this.context.commit(Mutations.SET_MAPPING_PROFILLING_HIERARCHY_PROFILLING_LOADING, false);
                        reject(false);
                    }
                })
                    .catch((err) => {
                    this.context.commit(Mutations.SET_MAPPING_PROFILLING_HIERARCHY_PROFILLING_LOADING, false);
                    reject(false);
                });
            });
        });
    }
    [_88 = Actions.GET_MAPPING_PROFILLING_HIERARCHY_PROFILLING_LISTALLDATA]() {
        return __awaiter(this, void 0, void 0, function* () {
            this.context.commit(Mutations.SET_MAPPING_PROFILLING_WAS_LOAD_QUICK_FILTER_HIERARCHY, false);
            const params = {
                ver: 'v1'
            };
            const url = process.env.VUE_APP_BASE_URL_DIGITAL +
                `/fincapex/api/master/hierarchyprofilling/filter?` +
                new URLSearchParams(params).toString();
            const paramsData = {
                Page: this.pageFilterHierarchy.toString(),
                Size: '10',
                Desc: this.descFilterHierarchy.toString(),
                SearchBy: this.searchByFilterHierarchy.toString(),
                IsActive: true
            };
            const dataId = [...this.ddlHierarchyProfillingId];
            const dataDesc = [...this.ddlHierarchyProfillingDesc];
            return new Promise((resolve, reject) => {
                ApiService.post(url, paramsData)
                    .then((res) => {
                    if (res.status === 200) {
                        if (res.data.result.content.paging.totalPages === this.pageFilter) {
                            this.context.commit(Mutations.SET_MAPPING_PROFILLING_WAS_LOAD_QUICK_FILTER_HIERARCHY, false);
                        }
                        else {
                            this.context.commit(Mutations.SET_MAPPING_PROFILLING_WAS_LOAD_QUICK_FILTER_HIERARCHY, true);
                        }
                        res.data.result.content.data.map((data) => {
                            dataId.push({
                                value: data.hierarchyProfillingId,
                                label: data.hierarchyProfillingId
                            });
                            dataDesc.push({
                                value: data.hierarchyProfillingDesc,
                                label: data.hierarchyProfillingDesc
                            });
                        });
                        this.context.commit(Mutations.SET_MAPPING_PROFILLING_HIERARCHY_PROFILLINGID, dataId);
                        this.context.commit(Mutations.SET_MAPPING_PROFILLING_HIERARCHY_PROFILLINGDESC, dataDesc);
                        resolve(true);
                    }
                    else {
                        this.context.commit(Mutations.SET_MAPPING_PROFILLING_WAS_LOAD_QUICK_FILTER_HIERARCHY, false);
                        reject(false);
                    }
                })
                    .catch((err) => {
                    this.context.commit(Mutations.SET_MAPPING_PROFILLING_WAS_LOAD_QUICK_FILTER_HIERARCHY, false);
                    reject(false);
                });
            });
        });
    }
    [_89 = Actions.UPDATE_MAPPING_PROFILLING](data) {
        return __awaiter(this, void 0, void 0, function* () {
            const url = process.env.VUE_APP_BASE_URL_DIGITAL +
                `/fincapex/api/master/mappingprofilling?ver=v1`;
            return new Promise((resolve, reject) => {
                ApiService.put(url, data)
                    .then((res) => {
                    if (res.status === 200) {
                        this.context.commit(Mutations.SET_MAPPING_PROFILLING_STATUS, {
                            status: res.data.statusCode,
                            message: res.data.result.message
                        });
                        this.context.commit(Mutations.SET_MAPPING_PROFILLING_HANDLE_PAGE, this.page);
                        this.context.dispatch(Actions.RESET_MAPPING_PROFILLING_FILTER);
                        resolve(true);
                    }
                    else {
                        reject(false);
                    }
                    return res;
                })
                    .catch(() => {
                    reject(false);
                });
            });
        });
    }
    [_90 = Actions.SUBMIT_MAPPING_PROFILLING_BULKREADYTOUPLOADED](data) {
        return __awaiter(this, void 0, void 0, function* () {
            this.context.commit(Mutations.SET_MAPPING_PROFILLING_LOADING, true);
            const url = process.env.VUE_APP_BASE_URL_DIGITAL +
                `/fincapex/api/master/mappingprofilling?ver=v1`;
            return new Promise((resolve, reject) => {
                ApiService.post(url, data)
                    .then((res) => {
                    if (res.status === 200) {
                        this.context.commit(Mutations.SET_MAPPING_PROFILLING_SUBMITBULK_STATUS, {
                            status: res.data.statusCode,
                            message: res.data.result.message
                        });
                        this.context.commit(Mutations.SET_MAPPING_PROFILLING_LISTBULK_READYTOUPLOADED, []);
                        this.context.commit(Mutations.SET_MAPPING_PROFILLING_LISTBULK, []);
                        this.context.commit(Mutations.SET_MAPPING_PROFILLING_LISTBULK_PAGE, []);
                        this.context.commit(Mutations.SET_MAPPING_PROFILLING_LOADING, false);
                        resolve(true);
                    }
                    else {
                        this.context.commit(Mutations.SET_MAPPING_PROFILLING_LOADING, false);
                        reject(false);
                    }
                    return res;
                })
                    .catch(() => {
                    this.context.commit(Mutations.SET_MAPPING_PROFILLING_LOADING, false);
                    reject(false);
                });
            });
        });
    }
    [_91 = Actions.CREATE_MAPPING_PROFILLING](data) {
        return __awaiter(this, void 0, void 0, function* () {
            const url = process.env.VUE_APP_BASE_URL_DIGITAL +
                `/fincapex/api/master/mappingprofilling?ver=v1`;
            return new Promise((resolve, reject) => {
                ApiService.post(url, data)
                    .then((res) => {
                    if (res.status === 200) {
                        this.context.commit(Mutations.SET_MAPPING_PROFILLING_STATUS, {
                            status: res.data.statusCode,
                            message: res.data.result.message
                        });
                        this.context.commit(Mutations.SET_MAPPING_PROFILLING_HANDLE_PAGE, this.page);
                        this.context.dispatch(Actions.RESET_MAPPING_PROFILLING_FILTER);
                        resolve(true);
                    }
                    else {
                        reject(false);
                    }
                    return res;
                })
                    .catch(() => {
                    reject(false);
                });
            });
        });
    }
    [_92 = Actions.UPLOAD_BULKMAPPING_PROFILLING](data) {
        return __awaiter(this, void 0, void 0, function* () {
            this.context.commit(Mutations.SET_MAPPING_PROFILLING_LOADING, true);
            this.context.commit(Mutations.SET_MAPPING_PROFILLING_LISTBULK_LOADING, true);
            const params = {
                ver: 'v1',
                Page: this.pageMappingProfillingBulkTemporary.toString(),
                Size: this.sizeMappingProfillingBulkTemporary.toString()
            };
            const url = process.env.VUE_APP_BASE_URL_DIGITAL +
                `/fincapex/api/master/mappingprofilling/upload?` +
                new URLSearchParams(params).toString();
            const formdata = new FormData();
            formdata.append('fileUpload', data.fileUpload);
            const dataReadyToUploaded = [];
            return new Promise((resolve, reject) => {
                ApiService.post(url, formdata)
                    .then((res) => {
                    if (res.status === 200) {
                        if (res.data.result.content.paging.errorRows === 0) {
                            res.data.result.content.data.map((data) => {
                                dataReadyToUploaded.push({
                                    companyCode: data.companyCode,
                                    assetNumber: data.assetNumber,
                                    assetSubNumber: data.assetSubNumber,
                                    hierarchyProfillingId: data.hierarchyProfillingId,
                                    vendorCode: data.vendorCode,
                                    projectCode: data.projectCode,
                                    validFrom: data.validFrom,
                                    validTo: data.validTo
                                });
                            });
                        }
                        this.context.commit(Mutations.SET_MAPPING_PROFILLING_LISTBULK_READYTOUPLOADED, dataReadyToUploaded);
                        this.context.commit(Mutations.SET_TOTALELEMENT_BULK_ERRORUPLOAD, res.data.result.content.paging.errorRows);
                        this.context.commit(Mutations.SET_TOTALELEMENT_BULK_UPLOAD, res.data.result.content.paging.totalElements);
                        this.context.commit(Mutations.SET_MAPPING_PROFILLING_LISTBULK, res.data.result.content.data);
                        this.context.commit(Mutations.SET_MAPPING_PROFILLING_LISTBULK_LOAD_PAGE, true);
                        this.context.commit(Mutations.SET_MAPPING_PROFILLING_LISTBULK_PAGE, res.data.result.content.paging);
                        this.context.commit(Mutations.SET_MAPPING_PROFILLING_LISTBULK_STATUS, {
                            status: res.data.statusCode,
                            message: res.data.result.message
                        });
                        this.context.commit(Mutations.SET_MAPPING_PROFILLING_LISTBULK_LOADING, false);
                        this.context.commit(Mutations.SET_MAPPING_PROFILLING_LOADING, false);
                        resolve(true);
                    }
                    else {
                        reject(false);
                        this.context.commit(Mutations.SET_MAPPING_PROFILLING_LISTBULK_LOADING, false);
                        this.context.commit(Mutations.SET_MAPPING_PROFILLING_LOADING, false);
                    }
                })
                    .catch((err) => {
                    reject(false);
                    this.context.commit(Mutations.SET_MAPPING_PROFILLING_LISTBULK_LOADING, false);
                    this.context.commit(Mutations.SET_MAPPING_PROFILLING_LOADING, false);
                });
            });
        });
    }
    [_93 = Actions.DOWNLOAD_MAPPING_PROFILLING]() {
        return __awaiter(this, void 0, void 0, function* () {
            const params = {
                ver: 'v1'
            };
            const url = process.env.VUE_APP_BASE_URL_DIGITAL +
                `/fincapex/api/master/mappingprofilling/download?` +
                new URLSearchParams(params).toString();
            const paramsData = {
                companyCode: this.selectedCompanyCode,
                assetNumber: this.selectedAssetNumber,
                assetSubNumber: this.selectedAssetSubNumber,
                assetDesc1: this.selectedAssetDesc1,
                assetDesc2: this.selectedAssetDesc2,
                vendorCode: this.selectedVendorName,
                hierarchyProfillingID: this.selectedHierarchyProfillingID,
                hierarchyProfillingDesc: this.selectedHierarchyProfillingDesc,
                projectCode: this.selectedProjectCode,
                projectDescription: this.selectedProjectName,
                validFrom: this.selectedValidFrom,
                validTo: this.selectedValidTo
            };
            // axios({
            //   url: url,
            //   method: 'POST',
            //   responseType: 'blob', // important
            return new Promise((resolve, reject) => {
                ApiService.post(url, paramsData)
                    .then((res) => {
                    const listDownload = JSON.parse(localStorage.getItem('exportFile') || '[]');
                    const found = listDownload.find((e) => {
                        return e == res.data.result.content;
                    });
                    if (!found) {
                        const dummyListDownload = [...listDownload, res.data.result.content];
                        localStorage.setItem('exportFile', JSON.stringify(dummyListDownload));
                    }
                    // eslint-disable-next-line comma-spacing
                    // const fileName = response.headers['content-disposition']
                    //   .split('; ')[1]
                    //   .split('=')[1]
                    //   .replaceAll('/', '-')
                    //   .replaceAll('"', '')
                    // const url = window.URL.createObjectURL(new Blob([response.data]))
                    // const link = document.createElement('a')
                    // link.href = url
                    // link.setAttribute('download', fileName)
                    // document.body.appendChild(link)
                    // link.click()
                    this.context.commit(Mutations.SET_MAPPING_PROFILLING_LOADING, false);
                    resolve(res);
                })
                    .catch((err) => {
                    reject(false);
                });
            });
        });
    }
    [_94 = Actions.DOWNLOAD_TEMPLATE_MAPPING_PROFILLING]() {
        return __awaiter(this, void 0, void 0, function* () {
            const apiUrl = `${process.env.VUE_APP_BASE_URL_DIGITAL}/fincapex/api/master/mappingprofilling/downloadtemplate?ver=v1`;
            axios({
                url: apiUrl,
                method: 'GET',
                responseType: 'blob' // important
            }).then((response) => {
                // eslint-disable-next-line comma-spacing
                const fileName = response.headers['content-disposition']
                    .split('; ')[1]
                    .split('=')[1]
                    .replaceAll('/', '-')
                    .replaceAll('"', '');
                const url = window.URL.createObjectURL(new Blob([response.data]));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', fileName);
                document.body.appendChild(link);
                link.click();
                this.context.commit(Mutations.SET_MAPPING_PROFILLING_LOADING, false);
            });
        });
    }
    [_95 = Actions.DOWNLOAD_TEMPLATE_UPDATE_MAPPING_PROFILLING]() {
        return __awaiter(this, void 0, void 0, function* () {
            const apiUrl = `${process.env.VUE_APP_BASE_URL_DIGITAL}/fincapex/api/master/mappingprofilling/downloadtemplateupdate?ver=v1`;
            axios({
                url: apiUrl,
                method: 'GET',
                responseType: 'blob' // important
            }).then((response) => {
                // eslint-disable-next-line comma-spacing
                const fileName = response.headers['content-disposition']
                    .split('; ')[1]
                    .split('=')[1]
                    .replaceAll('/', '-')
                    .replaceAll('"', '');
                const url = window.URL.createObjectURL(new Blob([response.data]));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', fileName);
                document.body.appendChild(link);
                link.click();
                this.context.commit(Mutations.SET_MAPPING_PROFILLING_LOADING, false);
            });
        });
    }
    [_96 = Actions.UPDATE_SELECTED_MAPPING_PROFILLING_ASSETNUMBER](data) {
        return __awaiter(this, void 0, void 0, function* () {
            this.context.commit(Mutations.SET_SELECTED_MAPPING_PROFILLING_COMPANYCODE, []);
            this.context.commit(Mutations.SET_SELECTED_MAPPING_PROFILLING_ASSETNUMBER, data);
            this.context.commit(Mutations.SET_SELECTED_MAPPING_PROFILLING_ASSETSUBNUMBER, []);
            this.context.commit(Mutations.SET_SELECTED_MAPPING_PROFILLING_ASSETDESC1, []);
            this.context.commit(Mutations.SET_SELECTED_MAPPING_PROFILLING_ASSETDESC2, []);
            this.context.commit(Mutations.SET_SELECTED_MAPPING_PROFILLING_VENDORNAME, []);
            this.context.dispatch(Actions.GET_MAPPING_PROFILLING_DATA);
        });
    }
    [_97 = Actions.UPDATE_SELECTED_MAPPING_PROFILLING_ASSETDESC1](data) {
        return __awaiter(this, void 0, void 0, function* () {
            this.context.commit(Mutations.SET_SELECTED_MAPPING_PROFILLING_COMPANYCODE, []);
            this.context.commit(Mutations.SET_SELECTED_MAPPING_PROFILLING_ASSETNUMBER, []);
            this.context.commit(Mutations.SET_SELECTED_MAPPING_PROFILLING_ASSETSUBNUMBER, []);
            this.context.commit(Mutations.SET_SELECTED_MAPPING_PROFILLING_ASSETDESC1, data);
            this.context.commit(Mutations.SET_SELECTED_MAPPING_PROFILLING_ASSETDESC2, []);
            this.context.commit(Mutations.SET_SELECTED_MAPPING_PROFILLING_VENDORNAME, []);
            this.context.dispatch(Actions.GET_MAPPING_PROFILLING_DATA);
        });
    }
    [_98 = Actions.RESET_MAPPING_PROFILLING_FILTER]() {
        return __awaiter(this, void 0, void 0, function* () {
            this.context.commit(Mutations.SET_MAPPING_PROFILLING_RESET, true);
            this.context.commit(Mutations.SET_MAPPING_PROFILLING_FILTERDDL_ASSETNUMBER, []);
            this.context.commit(Mutations.SET_SELECTED_MAPPING_PROFILLING_COMPANYCODE, []);
            this.context.commit(Mutations.SET_SELECTED_MAPPING_PROFILLING_ASSETNUMBER, []);
            this.context.commit(Mutations.SET_SELECTED_MAPPING_PROFILLING_ASSETSUBNUMBER, []);
            this.context.commit(Mutations.SET_SELECTED_MAPPING_PROFILLING_ASSETDESC1, []);
            this.context.commit(Mutations.SET_SELECTED_MAPPING_PROFILLING_ASSETDESC2, []);
            this.context.commit(Mutations.SET_SELECTED_MAPPING_PROFILLING_VENDORNAME, []);
            this.context.commit(Mutations.SET_SELECTED_MAPPING_PROFILLING_HIERARCHY_PROFILLINGID, []);
            this.context.commit(Mutations.SET_SELECTED_MAPPING_PROFILLING_HIERARCHY_PROFILLINGDESC, []);
            this.context.commit(Mutations.SET_SELECTED_MAPPING_PROFILLING_VALIDFROM, '');
            this.context.commit(Mutations.SET_SELECTED_MAPPING_PROFILLING_VALIDTO, '');
            this.context.commit(Mutations.SET_MAPPING_PROFILLING_USE_FILTER, true);
            this.context.dispatch(Actions.GET_MAPPING_PROFILLING_DATA);
        });
    }
    [_99 = Actions.UPDATE_MAPPING_PROFILLING_SIZE](data) {
        return __awaiter(this, void 0, void 0, function* () {
            this.context.commit(Mutations.SET_MAPPING_PROFILLING_SIZE, data);
            this.context.commit(Mutations.SET_MAPPING_PROFILLING_HANDLE_PAGE, 1);
            this.context.dispatch(Actions.GET_MAPPING_PROFILLING_DATA);
        });
    }
    [_100 = Actions.UPDATE_MAPPINGPROFILLING_VENDOR_SIZE](data) {
        return __awaiter(this, void 0, void 0, function* () {
            this.context.commit(Mutations.SET_MAPPING_PROFILLING_VENDOR_SIZE, data);
            this.context.commit(Mutations.SET_MAPPING_PROFILLING_VENDOR_HANDLE_PAGE, 1);
            this.context.dispatch(Actions.GET_MAPPING_PROFILLING_VENDOR_LIST);
        });
    }
    [_101 = Actions.DOWNLOAD_MAPPING_PROFILLING_BULK]() {
        return __awaiter(this, void 0, void 0, function* () {
            const params = {
                ver: 'v1'
            };
            const url = process.env.VUE_APP_BASE_URL_DIGITAL +
                `/fincapex/api/master/mappingprofilling/downloadvalidate?` +
                new URLSearchParams(params).toString();
            axios({
                url: url,
                method: 'GET',
                responseType: 'blob',
                data: {}
            }).then((response) => {
                const fileName = response.headers['content-disposition']
                    .split('; ')[1]
                    .split('=')[1]
                    .replaceAll('/', '-')
                    .replaceAll('"', '');
                const url = window.URL.createObjectURL(new Blob([response.data]));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', fileName);
                document.body.appendChild(link);
                link.click();
                this.context.commit(Mutations.SET_MAPPING_PROFILLING_LOADING, false);
            });
        });
    }
    [_102 = Actions.DOWNLOAD_MAPPING_PROFILLING_BULK_UPDATE](url) {
        return __awaiter(this, void 0, void 0, function* () {
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', 'errorreport.csv'); // or any other extension
            document.body.appendChild(link);
            link.click();
            this.context.commit(Mutations.SET_MAPPING_PROFILLING_LOADING, false);
        });
    }
    [_103 = Actions.UPDATE_MAPPING_PROFILLING_DESC_COMPANY_CODE](data) {
        return __awaiter(this, void 0, void 0, function* () {
            this.context.commit(Mutations.SET_MAPPING_PROFILLING_SELECTED_SEARCH_BY, data === '' ? '' : 'companyCode');
            this.context.commit(Mutations.SET_MAPPING_PROFILLING_SELECTED_DESC, data);
            this.context.commit(Mutations.SET_MAPPING_PROFILLING_PAGE_FILTER, 1);
            this.context.commit(Mutations.SET_MAPPING_PROFILLING_USE_FILTER, true);
            this.context.commit(Mutations.SET_MAPPING_PROFILLING_FILTERDDL_ASSETNUMBER, []);
            this.context.dispatch(Actions.GET_MAPPING_PROFILLING_LIST_POPULATEDDLFILTER);
        });
    }
    [_104 = Actions.UPDATE_MAPPING_PROFILLING_FIND_ASSET_NUMBER](data) {
        return __awaiter(this, void 0, void 0, function* () {
            this.context.commit(Mutations.SET_MAPPING_PROFILLING_SELECTED_SEARCH_BY, data === '' ? '' : 'assetnumber');
            this.context.commit(Mutations.SET_MAPPING_PROFILLING_SELECTED_DESC, data);
            this.context.commit(Mutations.SET_MAPPING_PROFILLING_PAGE_FILTER, 1);
            this.context.commit(Mutations.SET_MAPPING_PROFILLING_USE_FILTER, true);
            this.context.commit(Mutations.SET_MAPPING_PROFILLING_FILTERDDL_ASSETNUMBER, []);
            this.context.dispatch(Actions.GET_MAPPING_PROFILLING_LIST_POPULATEDDLFILTER);
        });
    }
    [_105 = Actions.UPDATE_MAPPING_PROFILLING_DESC_ASSET_NUMBER](data) {
        return __awaiter(this, void 0, void 0, function* () {
            this.context.commit(Mutations.SET_MAPPING_PROFILLING_SELECTED_SEARCH_BY, 'assetnumber');
            this.context.commit(Mutations.SET_MAPPING_PROFILLING_SELECTED_DESC, data);
            this.context.commit(Mutations.SET_MAPPING_PROFILLING_PAGE_FILTER, 1);
            this.context.commit(Mutations.SET_MAPPING_PROFILLING_USE_FILTER, true);
            this.context.commit(Mutations.SET_MAPPING_PROFILLING_FILTERDDL_ASSETNUMBER, []);
            this.context.dispatch(Actions.GET_MAPPING_PROFILLING_LIST_POPULATEDDLFILTER);
        });
    }
    [_106 = Actions.UPDATE_MAPPING_PROFILLING_ASSET_NUMBER_DESC](data) {
        return __awaiter(this, void 0, void 0, function* () {
            this.context.commit(Mutations.SET_MAPPING_PROFILLING_ASSET_SEARCH_BY, 'assetnumber');
            this.context.commit(Mutations.SET_MAPPING_PROFILLING_ASSET_DESC, data);
            this.context.commit(Mutations.SET_MAPPING_PROFILLING_PAGE_FILTER_ASSET, 1);
            this.context.commit(Mutations.SET_MAPPING_PROFILLING_ASSET_NUMBER, []);
            this.context.commit(Mutations.SET_MAPPING_PROFILLING_ASSET_SUB_NUMBER, []);
            this.context.commit(Mutations.SET_MAPPING_PROFILLING_ASSET_NAME_1, []);
            this.context.commit(Mutations.SET_MAPPING_PROFILLING_ASSET_NAME_2, []);
            this.context.dispatch(Actions.GET_MAPPING_PROFILLING_HIERARCHY_ASSET_LISTALLDATA);
        });
    }
    [_107 = Actions.UPDATE_MAPPING_PROFILLING_ASSET_SUB_NUMBER_DESC](data) {
        return __awaiter(this, void 0, void 0, function* () {
            this.context.commit(Mutations.SET_MAPPING_PROFILLING_ASSET_SEARCH_BY, 'assetSubNumber');
            this.context.commit(Mutations.SET_MAPPING_PROFILLING_ASSET_DESC, data);
            this.context.commit(Mutations.SET_MAPPING_PROFILLING_PAGE_FILTER_ASSET, 1);
            this.context.commit(Mutations.SET_MAPPING_PROFILLING_ASSET_NUMBER, []);
            this.context.commit(Mutations.SET_MAPPING_PROFILLING_ASSET_SUB_NUMBER, []);
            this.context.commit(Mutations.SET_MAPPING_PROFILLING_ASSET_NAME_1, []);
            this.context.commit(Mutations.SET_MAPPING_PROFILLING_ASSET_NAME_2, []);
            this.context.dispatch(Actions.GET_MAPPING_PROFILLING_HIERARCHY_ASSET_LISTALLDATA);
        });
    }
    [_108 = Actions.UPDATE_MAPPING_PROFILLING_ASSET_DESC1_DESC](data) {
        return __awaiter(this, void 0, void 0, function* () {
            this.context.commit(Mutations.SET_MAPPING_PROFILLING_ASSET_SEARCH_BY, 'assetDesc1');
            this.context.commit(Mutations.SET_MAPPING_PROFILLING_ASSET_DESC, data);
            this.context.commit(Mutations.SET_MAPPING_PROFILLING_PAGE_FILTER_ASSET, 1);
            this.context.commit(Mutations.SET_MAPPING_PROFILLING_ASSET_NUMBER, []);
            this.context.commit(Mutations.SET_MAPPING_PROFILLING_ASSET_SUB_NUMBER, []);
            this.context.commit(Mutations.SET_MAPPING_PROFILLING_ASSET_NAME_1, []);
            this.context.commit(Mutations.SET_MAPPING_PROFILLING_ASSET_NAME_2, []);
            this.context.dispatch(Actions.GET_MAPPING_PROFILLING_HIERARCHY_ASSET_LISTALLDATA);
        });
    }
    [_109 = Actions.UPDATE_MAPPING_PROFILLING_ASSET_DESC2_DESC](data) {
        return __awaiter(this, void 0, void 0, function* () {
            this.context.commit(Mutations.SET_MAPPING_PROFILLING_ASSET_SEARCH_BY, 'assetDesc2');
            this.context.commit(Mutations.SET_MAPPING_PROFILLING_ASSET_DESC, data);
            this.context.commit(Mutations.SET_MAPPING_PROFILLING_PAGE_FILTER_ASSET, 1);
            this.context.commit(Mutations.SET_MAPPING_PROFILLING_ASSET_NUMBER, []);
            this.context.commit(Mutations.SET_MAPPING_PROFILLING_ASSET_SUB_NUMBER, []);
            this.context.commit(Mutations.SET_MAPPING_PROFILLING_ASSET_NAME_1, []);
            this.context.commit(Mutations.SET_MAPPING_PROFILLING_ASSET_NAME_2, []);
            this.context.dispatch(Actions.GET_MAPPING_PROFILLING_HIERARCHY_ASSET_LISTALLDATA);
        });
    }
    [_110 = Actions.UPDATE_MAPPING_PROFILLING_VENDOR_CODE](data) {
        return __awaiter(this, void 0, void 0, function* () {
            this.context.commit(Mutations.SET_MAPPING_PROFILLING_VENDOR_SEARCH_BY, 'vendorCode');
            this.context.commit(Mutations.SET_MAPPING_PROFILLING_VENDOR_DESC, data);
            this.context.commit(Mutations.SET_MAPPING_PROFILLING_PAGE_FILTER_VENDOR, 1);
            this.context.commit(Mutations.SET_MAPPING_PROFILLING_VENDORID, []);
            this.context.commit(Mutations.SET_MAPPING_PROFILLING_VENDORNAME, []);
            this.context.commit(Mutations.SET_MAPPING_PROFILLING_VENDORIDNAME, []);
            this.context.dispatch(Actions.GET_MAPPING_PROFILLING_VENDOR_LISTALLDATA);
        });
    }
    [_111 = Actions.UPDATE_MAPPING_PROFILLING_HIERARCHY_ID](data) {
        return __awaiter(this, void 0, void 0, function* () {
            this.context.commit(Mutations.SET_MAPPING_PROFILLING_HIERARCHY_SEARCH_BY, 'HierarchyProfillingId');
            this.context.commit(Mutations.SET_MAPPING_PROFILLING_HIERARCHY_DESC, data);
            this.context.commit(Mutations.SET_MAPPING_PROFILLING_PAGE_FILTER_HIERARCHY, 1);
            this.context.commit(Mutations.SET_MAPPING_PROFILLING_HIERARCHY_PROFILLINGID, []);
            this.context.commit(Mutations.SET_MAPPING_PROFILLING_HIERARCHY_PROFILLINGDESC, []);
            this.context.dispatch(Actions.GET_MAPPING_PROFILLING_HIERARCHY_PROFILLING_LISTALLDATA);
        });
    }
    [_112 = Actions.UPDATE_MAPPING_PROFILLING_HIERARCHY_DESC](data) {
        return __awaiter(this, void 0, void 0, function* () {
            this.context.commit(Mutations.SET_MAPPING_PROFILLING_HIERARCHY_SEARCH_BY, 'HierarchyProfillingDesc');
            this.context.commit(Mutations.SET_MAPPING_PROFILLING_HIERARCHY_DESC, data);
            this.context.commit(Mutations.SET_MAPPING_PROFILLING_PAGE_FILTER_HIERARCHY, 1);
            this.context.commit(Mutations.SET_MAPPING_PROFILLING_HIERARCHY_PROFILLINGID, []);
            this.context.commit(Mutations.SET_MAPPING_PROFILLING_HIERARCHY_PROFILLINGDESC, []);
            this.context.dispatch(Actions.GET_MAPPING_PROFILLING_HIERARCHY_PROFILLING_LISTALLDATA);
        });
    }
    [_113 = Actions.UPDATE_BULKMAPPING_PROFILLING](data) {
        return __awaiter(this, void 0, void 0, function* () {
            this.context.commit(Mutations.SET_MAPPING_PROFILLING_LOADING, true);
            this.context.commit(Mutations.SET_MAPPING_PROFILLING_LISTBULK_LOADING, true);
            const params = {
                ver: 'v1'
            };
            const url = process.env.VUE_APP_BASE_URL_DIGITAL +
                `/fincapex/api/master/mappingprofilling/uploadupdate?` +
                new URLSearchParams(params).toString();
            const formdata = new FormData();
            formdata.append('fileUpload', data.fileUpload);
            return new Promise((resolve, reject) => {
                ApiService.post(url, formdata)
                    .then((res) => {
                    if (res.status === 200) {
                        this.context.commit(Mutations.SET_MAPPING_PROFILLING_LISTBULK_READYTOUPLOADED, res.data);
                        this.context.commit(Mutations.SET_MAPPING_PROFILLING_LISTBULK_LOADING, false);
                        this.context.commit(Mutations.SET_MAPPING_PROFILLING_LOADING, false);
                        resolve(res.data);
                    }
                    else {
                        reject(false);
                        this.context.commit(Mutations.SET_MAPPING_PROFILLING_LISTBULK_LOADING, false);
                        this.context.commit(Mutations.SET_MAPPING_PROFILLING_LOADING, false);
                    }
                })
                    .catch((err) => {
                    reject(false);
                    this.context.commit(Mutations.SET_MAPPING_PROFILLING_LISTBULK_LOADING, false);
                    this.context.commit(Mutations.SET_MAPPING_PROFILLING_LOADING, false);
                });
            });
        });
    }
    [_114 = Actions.SUBMIT_MAPPING_PROFILLING_BULKUPDATE](data) {
        return __awaiter(this, void 0, void 0, function* () {
            this.context.commit(Mutations.SET_MAPPING_PROFILLING_LOADING, true);
            const url = process.env.VUE_APP_BASE_URL_DIGITAL +
                `/fincapex/api/master/mappingprofilling?ver=v1`;
            return new Promise((resolve, reject) => {
                ApiService.put(url, data)
                    .then((res) => {
                    if (res.status === 200) {
                        this.context.commit(Mutations.SET_MAPPING_PROFILLING_SUBMITBULK_STATUS, {
                            status: res.data.statusCode,
                            message: res.data.result.message
                        });
                        this.context.commit(Mutations.SET_MAPPING_PROFILLING_LISTBULK_READYTOUPLOADED, []);
                        this.context.commit(Mutations.SET_MAPPING_PROFILLING_LISTBULK, []);
                        this.context.commit(Mutations.SET_MAPPING_PROFILLING_LISTBULK_PAGE, []);
                        this.context.commit(Mutations.SET_MAPPING_PROFILLING_LOADING, false);
                        resolve(true);
                    }
                    else {
                        this.context.commit(Mutations.SET_MAPPING_PROFILLING_LOADING, false);
                        reject(false);
                    }
                    return res;
                })
                    .catch(() => {
                    this.context.commit(Mutations.SET_MAPPING_PROFILLING_LOADING, false);
                    reject(false);
                });
            });
        });
    }
};
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], HierarchyModule.prototype, _a, null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], HierarchyModule.prototype, _b, null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], HierarchyModule.prototype, _c, null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], HierarchyModule.prototype, _d, null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], HierarchyModule.prototype, _e, null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], HierarchyModule.prototype, _f, null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], HierarchyModule.prototype, _g, null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], HierarchyModule.prototype, _h, null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], HierarchyModule.prototype, _j, null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], HierarchyModule.prototype, _k, null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], HierarchyModule.prototype, _l, null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], HierarchyModule.prototype, _m, null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], HierarchyModule.prototype, _o, null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], HierarchyModule.prototype, _p, null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], HierarchyModule.prototype, _q, null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], HierarchyModule.prototype, _r, null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], HierarchyModule.prototype, _s, null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], HierarchyModule.prototype, _t, null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], HierarchyModule.prototype, _u, null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], HierarchyModule.prototype, _v, null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], HierarchyModule.prototype, _w, null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], HierarchyModule.prototype, _x, null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], HierarchyModule.prototype, _y, null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], HierarchyModule.prototype, _z, null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], HierarchyModule.prototype, _0, null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], HierarchyModule.prototype, _1, null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], HierarchyModule.prototype, _2, null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], HierarchyModule.prototype, _3, null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], HierarchyModule.prototype, _4, null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], HierarchyModule.prototype, _5, null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], HierarchyModule.prototype, _6, null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], HierarchyModule.prototype, _7, null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], HierarchyModule.prototype, _8, null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], HierarchyModule.prototype, _9, null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], HierarchyModule.prototype, _10, null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], HierarchyModule.prototype, _11, null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], HierarchyModule.prototype, _12, null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], HierarchyModule.prototype, _13, null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], HierarchyModule.prototype, _14, null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], HierarchyModule.prototype, _15, null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], HierarchyModule.prototype, _16, null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], HierarchyModule.prototype, _17, null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], HierarchyModule.prototype, _18, null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], HierarchyModule.prototype, _19, null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], HierarchyModule.prototype, _20, null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], HierarchyModule.prototype, _21, null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], HierarchyModule.prototype, _22, null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], HierarchyModule.prototype, _23, null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], HierarchyModule.prototype, _24, null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], HierarchyModule.prototype, _25, null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], HierarchyModule.prototype, _26, null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], HierarchyModule.prototype, _27, null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], HierarchyModule.prototype, _28, null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], HierarchyModule.prototype, _29, null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], HierarchyModule.prototype, _30, null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], HierarchyModule.prototype, _31, null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], HierarchyModule.prototype, _32, null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], HierarchyModule.prototype, _33, null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], HierarchyModule.prototype, _34, null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], HierarchyModule.prototype, _35, null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], HierarchyModule.prototype, _36, null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], HierarchyModule.prototype, _37, null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], HierarchyModule.prototype, _38, null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], HierarchyModule.prototype, _39, null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], HierarchyModule.prototype, _40, null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], HierarchyModule.prototype, _41, null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], HierarchyModule.prototype, _42, null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], HierarchyModule.prototype, _43, null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], HierarchyModule.prototype, _44, null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], HierarchyModule.prototype, _45, null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], HierarchyModule.prototype, _46, null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], HierarchyModule.prototype, _47, null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], HierarchyModule.prototype, _48, null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], HierarchyModule.prototype, _49, null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], HierarchyModule.prototype, _50, null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], HierarchyModule.prototype, _51, null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], HierarchyModule.prototype, _52, null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], HierarchyModule.prototype, _53, null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], HierarchyModule.prototype, _54, null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], HierarchyModule.prototype, _55, null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], HierarchyModule.prototype, _56, null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], HierarchyModule.prototype, _57, null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], HierarchyModule.prototype, _58, null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], HierarchyModule.prototype, _59, null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], HierarchyModule.prototype, _60, null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], HierarchyModule.prototype, _61, null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], HierarchyModule.prototype, _62, null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], HierarchyModule.prototype, _63, null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], HierarchyModule.prototype, _64, null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], HierarchyModule.prototype, _65, null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], HierarchyModule.prototype, _66, null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], HierarchyModule.prototype, _67, null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], HierarchyModule.prototype, _68, null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], HierarchyModule.prototype, _69, null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], HierarchyModule.prototype, _70, null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], HierarchyModule.prototype, _71, null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], HierarchyModule.prototype, _72, null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], HierarchyModule.prototype, _73, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", Promise)
], HierarchyModule.prototype, _74, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", Promise)
], HierarchyModule.prototype, _75, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", Promise)
], HierarchyModule.prototype, _76, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", Promise)
], HierarchyModule.prototype, _77, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", Promise)
], HierarchyModule.prototype, _78, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", Promise)
], HierarchyModule.prototype, _79, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", Promise)
], HierarchyModule.prototype, _80, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", Promise)
], HierarchyModule.prototype, _81, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", Promise)
], HierarchyModule.prototype, _82, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", Promise)
], HierarchyModule.prototype, _83, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", Promise)
], HierarchyModule.prototype, _84, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", Promise)
], HierarchyModule.prototype, _85, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", Promise)
], HierarchyModule.prototype, _86, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", Promise)
], HierarchyModule.prototype, _87, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", Promise)
], HierarchyModule.prototype, _88, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", Promise)
], HierarchyModule.prototype, _89, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", Promise)
], HierarchyModule.prototype, _90, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", Promise)
], HierarchyModule.prototype, _91, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", Promise)
], HierarchyModule.prototype, _92, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", Promise)
], HierarchyModule.prototype, _93, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", Promise)
], HierarchyModule.prototype, _94, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", Promise)
], HierarchyModule.prototype, _95, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", Promise)
], HierarchyModule.prototype, _96, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", Promise)
], HierarchyModule.prototype, _97, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", Promise)
], HierarchyModule.prototype, _98, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", Promise)
], HierarchyModule.prototype, _99, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", Promise)
], HierarchyModule.prototype, _100, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", Promise)
], HierarchyModule.prototype, _101, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", Promise)
], HierarchyModule.prototype, _102, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", Promise)
], HierarchyModule.prototype, _103, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", Promise)
], HierarchyModule.prototype, _104, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", Promise)
], HierarchyModule.prototype, _105, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", Promise)
], HierarchyModule.prototype, _106, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", Promise)
], HierarchyModule.prototype, _107, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", Promise)
], HierarchyModule.prototype, _108, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", Promise)
], HierarchyModule.prototype, _109, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", Promise)
], HierarchyModule.prototype, _110, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", Promise)
], HierarchyModule.prototype, _111, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", Promise)
], HierarchyModule.prototype, _112, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", Promise)
], HierarchyModule.prototype, _113, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", Promise)
], HierarchyModule.prototype, _114, null);
HierarchyModule = __decorate([
    Module
], HierarchyModule);
export default HierarchyModule;
